import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PosCaptchaComponent } from './pos-captcha.component';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    PosCaptchaComponent
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [PosCaptchaComponent]
})
export class PosCaptchaModule { }
